'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  truncate: _propTypes2.default.bool
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var truncate = _ref.truncate,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['truncate', 'style']);

  var styles = {};

  if (truncate) {
    styles.whiteSpace = 'nowrap';
    styles.overflow = 'hidden';
    styles.textOverflow = 'ellipsis';
  }

  return _extends({ style: _extends({}, styles, style) }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvdHJ1bmNhdGUuanMiXSwibmFtZXMiOlsicHJvcFR5cGVzIiwidHJ1bmNhdGUiLCJib29sIiwicGFyc2VQcm9wcyIsInN0eWxlIiwicHJvcHMiLCJzdHlsZXMiLCJ3aGl0ZVNwYWNlIiwib3ZlcmZsb3ciLCJ0ZXh0T3ZlcmZsb3ciXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOzs7Ozs7OztBQUVPLElBQU1BLGdDQUFZO0FBQ3ZCQyxZQUFVLG9CQUFVQztBQURHLENBQWxCOztBQUlBLElBQU1DLGtDQUFhLFNBQWJBLFVBQWEsT0FJcEI7QUFBQSxNQUhKRixRQUdJLFFBSEpBLFFBR0k7QUFBQSxNQUZKRyxLQUVJLFFBRkpBLEtBRUk7QUFBQSxNQUREQyxLQUNDOztBQUNKLE1BQU1DLFNBQVMsRUFBZjs7QUFFQSxNQUFJTCxRQUFKLEVBQWM7QUFDWkssV0FBT0MsVUFBUCxHQUFvQixRQUFwQjtBQUNBRCxXQUFPRSxRQUFQLEdBQWtCLFFBQWxCO0FBQ0FGLFdBQU9HLFlBQVAsR0FBc0IsVUFBdEI7QUFDRDs7QUFFRCxvQkFBU0wsb0JBQVlFLE1BQVosRUFBdUJGLEtBQXZCLENBQVQsSUFBNENDLEtBQTVDO0FBQ0QsQ0FkTSIsImZpbGUiOiJ0cnVuY2F0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcblxuZXhwb3J0IGNvbnN0IHByb3BUeXBlcyA9IHtcbiAgdHJ1bmNhdGU6IFByb3BUeXBlcy5ib29sXG59XG5cbmV4cG9ydCBjb25zdCBwYXJzZVByb3BzID0gKHtcbiAgdHJ1bmNhdGUsXG4gIHN0eWxlLFxuICAuLi5wcm9wc1xufSkgPT4ge1xuICBjb25zdCBzdHlsZXMgPSB7fVxuXG4gIGlmICh0cnVuY2F0ZSkge1xuICAgIHN0eWxlcy53aGl0ZVNwYWNlID0gJ25vd3JhcCdcbiAgICBzdHlsZXMub3ZlcmZsb3cgPSAnaGlkZGVuJ1xuICAgIHN0eWxlcy50ZXh0T3ZlcmZsb3cgPSAnZWxsaXBzaXMnXG4gIH1cblxuICByZXR1cm4geyBzdHlsZTogeyAuLi5zdHlsZXMsIC4uLnN0eWxlIH0sIC4uLnByb3BzIH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/truncate.js
// module id = 1155
// module chunks = 0